/**
 * Default-prompt API + Prompt field are only for Insight ↔ Docs
 * (either Reference→Impact direction).
 */
export function normalizeOtoObjectTypeCode(code: string): string {
  return code.trim().toLowerCase();
}

function isDocsType(code: string): boolean {
  return code === "docs" || code === "doc";
}

export function isOtoInsightToDocsPair(
  referenceObjectType: string,
  impactedObjectType: string,
): boolean {
  const reference = normalizeOtoObjectTypeCode(referenceObjectType);
  const impact = normalizeOtoObjectTypeCode(impactedObjectType);
  return (
    (reference === "insight" && isDocsType(impact)) ||
    (isDocsType(reference) && impact === "insight")
  );
}
